<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-12">
                                <label for="label" class="form-label">Comment <b class="text-secondary">*</b></label>
                                <textarea type="text" class="form-control ps-1" id="comment"
                                    placeholder="Enter your Comment" [(ngModel)]="employeeAssesment.loneComments" autocomplete="off"
                                    [readonly]="isActive"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>